import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Route guard per tipo struttura (clubNature).
 *
 * Difesa in profondità: le voci di menu vengono già nascoste in base al tipo struttura,
 * ma senza questa guardia le pagine restano raggiungibili via URL diretto da qualunque
 * tipo. Se il clubNature dell'utente non è tra quelli consentiti, reindirizza alla dashboard.
 *
 * Uso:
 *   <ClubNatureGuard allow={['ASD','SSD','CAPITAL_COMPANY']}><SociTable/></ClubNatureGuard>
 */
const ClubNatureGuard = ({ allow = [], children }) => {
    let clubNature = null;
    try {
        clubNature = JSON.parse(sessionStorage.getItem('userDetails'))?.clubNature ?? null;
    } catch (e) {
        clubNature = null;
    }

    if (!clubNature || !allow.includes(clubNature)) {
        return <Navigate to="/struttura/dashboard" replace />;
    }

    return children;
};

export default ClubNatureGuard;
